import React, { useEffect, useState } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { handleClose } from "./HandleClosePop/handleclose";
import { setPersonalInfos } from "../../Slices/employeeslice";
import { InputField } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
export const IdProofPop = () => {
    const {handleSubmit}=useFormHandler()
    const dispatch = useDispatch()
    const proof = useSelector((state) => state.employee.personalInfo);
    useEffect(() => {
        setPersonalInfo({
            adharNumber: proof?.adharNumber,
            PanNumber: proof?.PanNumber,
            UAN: proof?.UAN,
            EsiNo: proof?.EsiNo,
            PfNo: proof?.PfNo,
            HealthInsuranceNo: proof?.HealthInsuranceNo,
        });

    }, [proof])
    const [personalInfo, setPersonalInfo] = useState({});
    const [personalValid, setpersonalValid] = useState(false);
    const [Personalerrors, setPersonalErrors] = useState({});
    const adharPattern = /^[0-9]{12}$/; // 12 digits for Adhar
    const pfPattern = /^[A-Z]{2}\/[A-Z]{3}\/\d{7}\/\d{3}\/\d{7}$/;// Alphanumeric characters for PF Number
    const uanPattern = /^[0-9]{12}$/; // 12 digits for UAN
    const esiPattern = /^[0-9]{10}$/; // 10 digits for ESI
    const healthInsurancePattern = /^[0-9]{10,15}$/; // 10-1


    const PersonalhandleInputChange = (e) => {
        const { name, value } = e.target;
        // Update personal information state
        setPersonalInfo({ ...personalInfo, [name]: value });
        // Create a copy of the errors
        let updatedErrors = { ...Personalerrors };
        // List of required fields
        const requiredFields = ['adharNumber', 'PfNo', 'UAN', 'EsiNo', 'HealthInsuranceNo'];
        // Validation logic
        if (name === 'adharNumber') {
            if (!value.trim()) {
                delete updatedErrors.adharNumber;
            } else if (!adharPattern.test(value)) {
                updatedErrors.adharNumber = "Invalid Adhar Number. It should be 12 digits.";
            } else {
                delete updatedErrors.adharNumber;
            }
        }

        if (name === 'PfNo') {
            if (!value.trim()) {
                delete updatedErrors.PfNo;
            } else if (!pfPattern.test(value)) {
                updatedErrors.PfNo = "Invalid PF Number. It should be alphanumeric.";
            } else {
                delete updatedErrors.PfNo;
            }
        }

        if (name === 'UAN') {
            if (!value.trim()) {
                delete updatedErrors.UAN;
            } else if (!uanPattern.test(value)) {
                updatedErrors.UAN = "Invalid UAN. It should be 12 digits.";
            } else {
                delete updatedErrors.UAN;
            }
        }

        if (name === 'EsiNo') {
            if (!value.trim()) {
                delete updatedErrors.EsiNo;
            } else if (!esiPattern.test(value)) {
                updatedErrors.EsiNo = "Invalid ESI Number. It should be 10 digits.";
            } else {
                delete updatedErrors.EsiNo;
            }
        }

        if (name === 'HealthInsuranceNo') {
            if (!value.trim()) {
                delete updatedErrors.HealthInsuranceNo;
            } else if (!healthInsurancePattern.test(value)) {
                updatedErrors.HealthInsuranceNo = "Invalid Health Insurance Number. It should be 10-15 digits.";
            } else {
                delete updatedErrors.HealthInsuranceNo;
            }
        }

        // Update errors in state
        setPersonalErrors(updatedErrors);
        setpersonalValid(true);

    };
    const PersonalhandleSubmit = async (e) => {
        e.preventDefault();
        // Flag to track if any field is valid
        let isAnyFieldValid = false;
        let newErrors = { ...Personalerrors };
        // Temporary object to store validation errors
        if (personalInfo.adharNumber && adharPattern.test(personalInfo.adharNumber)) {
            isAnyFieldValid = true;
        }
        if (personalInfo.PfNo && pfPattern.test(personalInfo.PfNo)) {
            isAnyFieldValid = true;
        }
        if (personalInfo.UAN && uanPattern.test(personalInfo.UAN)) {
            isAnyFieldValid = true;
        }
        if (personalInfo.EsiNo && esiPattern.test(personalInfo.EsiNo)) {
            isAnyFieldValid = true;
        }
        if (personalInfo.HealthInsuranceNo && healthInsurancePattern.test(personalInfo.HealthInsuranceNo)) {
            isAnyFieldValid = true;
        }
        const noErrors = Object.keys(newErrors).length === 0;
        try {
            const val = await handleSubmit({
                noErrors,
                formValid: personalValid,
                dataObj: personalInfo,
                action: "EmployeeStatus",
                ModalName: "EmployeeModalpopup",
                submitAction: "EmployeeStatusSubmit",
            });
            if (val) {
                dispatch(setPersonalInfos(personalInfo));
                setpersonalValid(false)
            }
        } catch (error) {
            message.error({
                content: "Failed to update PersonalhandleSubmit . Please try again.",
                duration: 5,
                className: "custom-toast-center",
            });
        } finally {
            // Final steps regardless of success or failure
            setpersonalValid(false); // Ensure form state resets
        }

    };
    return (

        <Modal id="personal_info_modal"
         handleModalClose={() =>
          handleClose(proof,
          setPersonalInfo,
          setPersonalErrors)}
           title="Personal Information"
            handleSubmit={PersonalhandleSubmit}
             isUserDataValid={false}>
            <div className="row">
                {/* Aadhar Number */}
                <div className="col-md-6 mb-2">
                    <InputField
                        formcontrol="form-control"
                        // required={true}
                        type="text"
                        label="Aadhar Number"
                        name="adharNumber"
                        value={personalInfo?.adharNumber || ''}
                        onChange={PersonalhandleInputChange}
                        error={Personalerrors?.adharNumber}
                    />
                </div>

                {/* PF Number */}
                <div className="col-md-6 mb-2">
                    <InputField
                        formcontrol="form-control"
                        // required={true}
                        type="text"
                        label="PF Number"
                        name="PfNo"
                        value={personalInfo?.PfNo || ''}
                        onChange={PersonalhandleInputChange}
                        error={Personalerrors?.PfNo}
                    />
                </div>
                {/* UAN */}
                <div className="col-md-6 mb-2">
                    <InputField
                        formcontrol="form-control"
                        // required={true}
                        type="text"
                        label="UAN"
                        name="UAN"
                        value={personalInfo?.UAN || ''}
                        onChange={PersonalhandleInputChange}
                        error={Personalerrors?.UAN}
                    />
                </div>

                {/* ESI Number */}
                <div className="col-md-6 mb-2">
                    <InputField
                        formcontrol="form-control"
                        // required={true}
                        type="text"
                        label="ESI Number"
                        name="EsiNo"
                        value={personalInfo?.EsiNo || ''}
                        onChange={PersonalhandleInputChange}
                        error={Personalerrors?.EsiNo}
                    />
                </div>

                {/* Health Insurance Number */}
                <div className="col-md-6 mb-2">
                    <InputField
                        formcontrol="form-control"
                        type="text"
                        // required={true}
                        label="Health Insurance No"
                        name="HealthInsuranceNo"
                        value={personalInfo?.HealthInsuranceNo || ''}
                        onChange={PersonalhandleInputChange}
                        error={Personalerrors?.HealthInsuranceNo}
                    />
                </div>
            </div>
        </Modal>

    )
}